import { render, staticRenderFns } from "./actionPoints.vue?vue&type=template&id=0a36a510&scoped=true"
import script from "./actionPoints.vue?vue&type=script&lang=js"
export * from "./actionPoints.vue?vue&type=script&lang=js"
import style0 from "./actionPoints.vue?vue&type=style&index=0&id=0a36a510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36a510",
  null
  
)

export default component.exports